import IconPause from 'approot/shared/icons/icon-pause';
import IconPlay from 'approot/shared/icons/icon-play';
import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/secondary-button.style';
import TooltipWrapper from 'approot/shared/tooltip/tooltip-wrapper';

type Props = {
  isPlaying: boolean;
  altText?: string | null;
  onClick: () => void;
};

const ComponentPlayPause = ({ isPlaying, altText, onClick }: Props) => {
  return (
    <TooltipWrapper hoverText={isPlaying ? 'Pause' : 'Play'}>
      <SecondaryButtonIcon
        type="button"
        data-selector={isPlaying ? 'icon-pause' : 'icon-play'}
        aria-label={`${isPlaying ? 'Pause' : 'Play'}${
          altText ? ` ${altText}` : ''
        }`}
        onClick={onClick}
      >
        {!isPlaying ? (
          <IconPlay width={16} height={16} />
        ) : (
          <IconPause width={16} height={16} />
        )}
      </SecondaryButtonIcon>
    </TooltipWrapper>
  );
};

export default ComponentPlayPause;
